import { useEffect } from 'react'
import { useForm, useWatch } from 'react-hook-form'

import ConnectWallet from 'src/ui/molecules/ConnectWallet'
import WrappedInput from 'src/ui/atoms/Input/Wrapped'
import Button from 'src/ui/atoms/Button'
import useQueryParams from 'src/hooks/useQueryParams'
import useIssueEvmNft from './useIssueEvmNft'

const EsdtForm = ({ chain }: { chain: string }) => {
  const network = 'testnet'
  const { isLoading, isWalletConnected, issueNft } = useIssueEvmNft({
    operation: 'create NFT collection',
    projectType: 'nft',
  })

  const { defaultValues, setParams } = useQueryParams({
    fields: [
      { name: 'nftCollectionName' },
      { name: 'nftContractName' },
      { name: 'nftSymbol' },
      { name: 'nftMaxSupply', initialValue: 100 },
    ],
  })

  const {
    register,
    handleSubmit,
    control,
    formState: { errors, isValid },
  } = useForm({
    mode: 'onChange',
    defaultValues,
  })

  const watchData = useWatch({ control })

  useEffect(() => {
    setParams(watchData)
  }, [watchData])

  const handleCreate = async (data: any) => {
    await issueNft({
      ...data,
      network,
      chain,
    })
  }

  return (
    <div className="grid gap-12">
      <ConnectWallet network={network} chain={chain} />
      <form className="grid gap-12" onSubmit={handleSubmit((data) => handleCreate(data as any))}>
        <div className="grid gap-4">
          <h2 className="text-white">Settings</h2>
          <WrappedInput
            placeholder="Collection name"
            label="Collection name"
            error={errors.nftCollectionName}
            {...register('nftCollectionName', {
              required: 'Required field',
              pattern: {
                value: /^[a-zA-Z0-9]{3,20}$/,
                message: 'Alphanumeric characters only, between 3 and 20 characters',
              },
            })}
          />
          <WrappedInput
            placeholder='e.g. "NCT"'
            label="Symbol"
            error={errors.nftSymbol}
            {...register('nftSymbol', {
              required: 'Required field.',
              pattern: {
                value: /^[A-Z0-9]{3,10}$/,
                message: 'Alphanumeric uppercase characters only, between 3 and 10 characters',
              },
            })}
          />
          <WrappedInput
            placeholder="Contract name"
            label="Contract name"
            error={errors.nftContractName}
            {...register('nftContractName', {
              required: 'Required field',
              pattern: {
                value: /^[a-zA-Z0-9]{3,20}$/,
                message: 'Alphanumeric characters only, between 3 and 20 characters',
              },
            })}
          />
          <WrappedInput
            placeholder="Supply"
            label="Supply"
            error={errors.nftMaxSupply}
            type="number"
            {...register('nftMaxSupply', {
              required: 'Required field',
            })}
          />
        </div>

        <div className="ml-auto">
          <Button name="Create NFT" loading={isLoading} disabled={!isValid || !isWalletConnected} />
        </div>
      </form>
    </div>
  )
}

export default EsdtForm
